module.exports = __webpack_public_path__ + "img/avatar-7.6623c0df.jpg";